import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { setPlayAddress } from '../slice/commonSlice';
import { useEffect, useMemo } from 'react';
import { useAccount } from 'wagmi';
import { reselectUserInfoInPlayerList } from '../slice/reselectors';

export const useRefreshPlayAddress = () => {
  const { playAddress, setPlayAdd } = usePlayAddress();
  // 坐下的用户/ 在玩的用户
  const playersInfo = useSelector(reselectUserInfoInPlayerList);
  const { address } = useAccount();
  // 页面刷新时，如果用户已经是坐下的状态，但store中playAddress为空，此时需要设置playAddress
  useEffect(() => {
    if (!playAddress && address) {
      const isSit = playersInfo.some(
        v => v.userAddress?.toLowerCase() === address.toLowerCase()
      );
      if (isSit) {
        setPlayAdd(address);
      }
    }
  }, [playAddress, playersInfo, address, setPlayAdd]);
};

export const usePlayAddress = () => {
  const { playAddress } = useSelector((state: RootState) => state.common);
  const dispatch = useDispatch();

  // 设置currentJwt
  const setPlayAdd = (address?: `0x${string}`) => {
    address && dispatch(setPlayAddress(address));
  };

  return {
    playAddress,
    setPlayAdd,
  };
};

// current play address use in game page or setting page
export const usePlayAccount = () => {
  const { playAddress } = usePlayAddress();
  const { address: connectAddress, ...rest } = useAccount();
  const address = useMemo(() => {
    return playAddress || connectAddress;
  }, [playAddress, connectAddress]) as `0x${string}`;

  return {
    address,
    ...rest,
  };
};
